import { useUsersLinkableAccountsList } from "@sidegigllc/api/client";
import { useSearch } from "@tanstack/react-router";
import { isAccountLinkingSkipped } from "domains/auth/accountLinking";

type UseLinkableAccountsStatusProps = {
  signUpRequired: boolean;
};

export function useLinkableAccountsStatus({ signUpRequired }: UseLinkableAccountsStatusProps) {
  const { skipAccountLinking } = useSearch({ strict: false });
  // Redirects out of sign-up drop the param.
  const optedOut = skipAccountLinking === true || isAccountLinkingSkipped();
  const isAccountLinkingEnabled = !optedOut && signUpRequired;

  const linkableAccounts = useUsersLinkableAccountsList("me", {
    query: {
      enabled: isAccountLinkingEnabled,
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
  // Undefined on error too, not just while loading.
  const linkingRequired = (linkableAccounts.data?.length ?? 0) > 0;

  if (!isAccountLinkingEnabled) return "idle";
  if (linkableAccounts.isLoading) return "loading";
  if (linkingRequired) return "linking-required";
  return linkableAccounts.status === "pending" ? "loading" : linkableAccounts.status;
}
